import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    errorMessage: null,

    dataPage: null,
    filterProperties: null,

    detailsModal: true,
    detailsErrorMessage: null,
    wereOnDetailsPage: false,
    details: null,

    deletionModal: false,
    modalErrorMessage: null,

    exportLoading: false,
    downloadLoading: false,
    exportDownloadFile: null,
    downloadLinkModal: false,
    exportBlocked: false,
    exportInfoMessage: undefined,
    exportSuccessMessage: undefined,

    csvExportModal: false,
    xmlExportModal: false,
    datevUOExportModal: false,

    compressLoading: false,
    compressErrorMessage: null,
    compressSuccessMessage: null,

    summaryLoading: false,
    summaryData: null,
    summaryErrorMessage: null,
};

const accountingTasksSlice = createSlice({
    name: "AccountingTask",
    initialState: initialState,
    reducers: {
        getAllAccountingTasksRequest(state, action) {
            state.dataPage = {
                filterProperties: action.payload,
            };
            state.loading = true;
            state.errorMessage = null;
        },
        getAllAccountingTasksSuccess(state, action) {
            state.loading = false;
            if (state.dataPage && state.dataPage.filterProperties) {
                state.filterProperties = { ...state.filterProperties, ...state.dataPage.filterProperties };
            }
            state.dataPage = action.payload;
        },
        getAllAccountingTasksFailure(state, action) {
            if (action.payload.clearItems) {
                state.dataPage = null;
            }

            state.loading = false;
            state.errorMessage = action.payload.errorMessage;
        },

        getAccountingTaskDetailsRequest(state) {
            state.loading = true;
            state.detailsErrorMessage = null;
            state.details = null;
        },
        getAccountingTaskDetailsSuccess(state, action) {
            state.detailsModal = true;
            state.details = action.payload;
            state.loading = false;
            state.wereOnDetailsPage = true;
        },
        getAccountingTaskDetailsFailure(state, action) {
            state.detailsModal = false;
            state.loading = false;
            state.detailsErrorMessage = action.payload;
        },

        toggleAccountingTaskDeletionModal(state) {
            state.deletionModal = !state.deletionModal;
        },

        deleteAccountingTaskRequest(state) {
            state.subloading = true;
            state.modalErrorMessage = null;
        },
        deleteAccountingTaskSuccess(state) {
            state.subloading = false;
            state.deletionModal = false;
        },
        deleteAccountingTaskFailure(state, action) {
            state.subloading = false;
            state.deletionModal = true;
            state.modalErrorMessage = action.payload;
        },

        toggleCsvExportModal(state) {
            state.csvExportModal = !state.csvExportModal;
            state.modalErrorMessage = state.csvExportModal ? null : state.modalErrorMessage; // clear when closing the modal,
            state.exportBlocked = false;
            state.exportSuccessMessage = undefined;
            state.exportDownloadFile = null;
        },
        exportAccountingTaskAsCSVRequest(state) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
        },

        downloadAccountingTasks(state) {
            state.modalErrorMessage = null;
            state.downloadLoading = true;
        },
        exportSingleAccountingTaskAsCSVRequest(state, action) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
            state.exportTaskId = action.payload
        },

        exportAccountingTaskAsCSVSuccess(state, action) {
            state.exportLoading = false;
            state.exportDownloadFile = action.payload;
            state.csvExportModal = false;
            state.exportTaskId = null;
            state.downloadLoading = false;
        },
        exportAccountingTaskAsCSVFailure(state, action) {
            state.exportLoading = false;
            state.modalErrorMessage = action.payload;
            state.exportTaskId = null;
            state.downloadLoading = false;
        },

        exportAccountingTaskAsExcelRequest(state) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
        },
        exportAccountingTaskAsExcelSuccess(state, action) {
            state.exportLoading = false;
            state.exportDownloadFile = action.payload;
            state.csvExportModal = false;
            state.downloadLinkModal = true;
        },
        exportAccountingTaskAsExcelFailure(state, action) {
            state.exportLoading = false;
            state.csvExportModal = true;
            state.modalErrorMessage = action.payload;
        },

        toggleXmlExportModal(state) {
            state.xmlExportModal = !state.xmlExportModal;
            state.modalErrorMessage = state.xmlExportModal ? null : state.modalErrorMessage; // clear when closing the modal,
            state.exportBlocked = false;
            state.exportSuccessMessage = undefined;
            state.exportDownloadFile = null;
        },
        exportAccountingTaskAsXMLRequest(state) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
            state.exportDownloadFile = null;
        },
        exportAccountingTaskAsXMLSuccess(state, action) {
            state.exportLoading = false;
            if (action.payload) {
                state.exportDownloadFile = action.payload;
                state.xmlExportModal = false;
                state.downloadLinkModal = true;
            } else {
                state.exportSuccessMessage =
                    "Der Buchungsstapel wird nun exportiert und der Download-Link im Anschluss an deine E-Mail versand.";
                state.xmlExportModal = true;
            }
        },
        exportAccountingTaskAsXMLFailure(state, action) {
            state.exportLoading = false;
            state.modalErrorMessage = action.payload;
            state.xmlExportModal = true;
        },

        toggleDatevUOExportModal(state) {
            state.datevUOExportModal = !state.datevUOExportModal;
            state.modalErrorMessage = state.datevUOExportModal ? null : state.modalErrorMessage; // clear when closing the modal,
            state.exportBlocked = false;
            state.exportInfoMessage = undefined;
            state.exportSuccessMessage = undefined;
        },
        exportAccountingTaskToDatevUORequest(state) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
            state.exportInfoMessage = null;
            state.exportSuccessMessage = null;
        },
        exportAccountingTaskToDatevUOSuccess(state, action) {
            state.exportLoading = false;
            if (action.payload && action.payload.warningMessage) {
                state.exportInfoMessage = action.payload.warningMessage;
            } else if (action.payload && action.payload.successMessage) {
                state.exportSuccessMessage = action.payload.successMessage;
            } else {
                state.exportSuccessMessage =
                    "Der Buchungsstapel wurde erfolgreich zum DATEV Buchungsdatenservice übertragen";
            }
        },
        exportAccountingTaskToDatevUOFailure(state, action) {
            state.exportLoading = false;
            state.modalErrorMessage = action.payload;
        },
        
        toggleDuplicatesExportModal(state) {
            state.duplicatesExportModal = !state.duplicatesExportModal;
            state.modalErrorMessage = state.duplicatesExportModal ? null : state.modalErrorMessage; // clear when closing the modal,
            state.exportBlocked = false;
            state.exportSuccessMessage = undefined;
            state.exportDownloadFile = null;
        },
        handleDuplicatesExportRequestChange(state, action) {
            state.duplicatesExportRequest = action.payload;
        },
 
        exportDuplicatesForAccountingTaskRequest(state) {
            state.modalErrorMessage = null;
            state.exportLoading = true;
            state.exportInfoMessage = null;
            state.exportSuccessMessage = null;
        },
        exportDuplicatesForAccountingTaskSuccess(state, action) {
            state.exportLoading = false;
            state.duplicatesExportModal = null;
            if (action.payload && action.payload.warningMessage) {
                state.exportInfoMessage = action.payload.warningMessage;
            } else if (action.payload && action.payload.successMessage) {
                state.exportSuccessMessage = action.payload.successMessage;
            } else {
                state.exportSuccessMessage =
                    "Duplikate aus dem Stapel werden exportiert. Wenn entsprechende Option ausgewählt wurde, wird ein neuer Stapel erstellt. " + 
                    "Duplikate werden dabei rückgängig gemacht.";
            }
        },
        exportDuplicatesForAccountingTaskFailure(state, action) {
            state.exportLoading = false;
            state.modalErrorMessage = action.payload;
        },

        toggleAccountingTaskDownloadModal(state) {
            state.downloadLinkModal = !state.downloadLinkModal;
            state.exportDownloadId = null;
        },

        setAccountingTaskExportModalErrorMessage(state, action) {
            state.modalErrorMessage = action.payload;
            state.exportBlocked = true;
        },
        clearDetailsReferrer(state) {
            state.wereOnDetailsPage = false;
        },
        clearAccountingTasks() {
            return initialState;
        },

        compressAccountingTasksRequest(state) {
            state.compressLoading = true;
            state.compressErrorMessage = null;
            state.compressSuccessMessage = null;
            state.modalErrorMessage = null;
        },
        compressAccountingTasksSuccess(state) {
            state.compressLoading = false;
            state.compressErrorMessage = null;
            state.compressSuccessMessage =
                "Der komprimierte Buchungsstapel wird jetzt erstellt und ist dann hier verfügbar.";
        },
        compressAccountingTasksFailure(state, action) {
            state.compressLoading = false;
            state.compressSuccessMessage = null;
            state.compressErrorMessage = action.payload;
            state.modalErrorMessage = action.payload;
        },

        getAccountingTaskSummaryRequest(state) {
            state.summaryLoading = true;
            state.summaryErrorMessage = null;
            state.summaryData = null;
        },
        getAccountingTaskSummarySuccess(state, action) {
            state.summaryLoading = false;
            state.summaryData = action.payload;
        },
        getAccountingTaskSummaryFailure(state, action) {
            state.summaryLoading = false;
            state.summaryErrorMessage = action.payload;
        },

        clearAccountingTaskSummary(state) {
            state.summaryLoading = false;
            state.summaryData = null;
            state.summaryErrorMessage = null;
        },
    },
});

export default accountingTasksSlice;
